export default "__VITE_ASSET__1a10a6e1__$_?component__"